import AboutUsHeader from './AboutUsHeader';
import AboutUsSubtitle from './AboutUsSubtitle';
import AboutUsBody from './AboutUsBody';
import AboutUsWrapper from './AboutUsWrapper';
import AboutUsReview from './AboutUsReview';
import AboutUsVideoWrapper from './AboutUsVideoWrapper';

export { AboutUsBody, AboutUsHeader, AboutUsReview, AboutUsSubtitle, AboutUsWrapper, AboutUsVideoWrapper };
